import React, { Fragment, useRef, useState, useCallback, useEffect } from 'react';
import AntAPI from '../../utils/AntAPI';
import AntLocalization from '../../utils/AntLocalization';

var aivaAPI = null;
function getAPI() {
    if (!aivaAPI) aivaAPI = new AntAPI('ai', 'AIVoucherAnalysis');
    return aivaAPI;
}

function IconUpload() {
    return (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
            <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
        </svg>
    );
}
function IconZap() {
    return <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M13 2 3 14h7l-1 8 10-12h-7l1-8z" /></svg>;
}
function IconScale() {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="3" />
            <circle cx="12" cy="12" r="8" />
            <line x1="12" y1="2" x2="12" y2="4" />
            <line x1="12" y1="20" x2="12" y2="22" />
            <line x1="2" y1="12" x2="4" y2="12" />
            <line x1="20" y1="12" x2="22" y2="12" />
        </svg>
    );
}
function IconDeep() {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="8" y1="13" x2="16" y2="13" />
            <line x1="8" y1="17" x2="16" y2="17" />
            <line x1="8" y1="9" x2="11" y2="9" />
        </svg>
    );
}
function IconSparkle() {
    return <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2 14 9l7 2-7 2-2 7-2-7-7-2 7-2z" /></svg>;
}
function IconInfo() {
    return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
    );
}
function IconArrowUp() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="19" x2="12" y2="5" />
            <polyline points="5 12 12 5 19 12" />
        </svg>
    );
}
function IconFile(props) {
    var color = props.color || '#64748b';
    return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
        </svg>
    );
}
function IconImage(props) {
    var color = props.color || '#64748b';
    return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <polyline points="21 15 16 10 5 21" />
        </svg>
    );
}

var MODES = [
    { code: 'Quick', name: { vi: 'Nhanh', en: 'Quick', fr: 'Rapide', es: 'Rápido', id: 'Cepat', ja: '高速', zh: '快速', ko: '빠름', hi: 'तेज़', ar: 'سريع' }, hint: { vi: 'Cho tài liệu rõ ràng, ít dòng', en: 'For clear documents with few lines', fr: 'Pour documents nets, peu de lignes', es: 'Para documentos claros y con pocas filas', id: 'Untuk dokumen jelas, sedikit baris', ja: '鮮明で行数の少ない文書向け', zh: '适用于清晰、行数少的文档', ko: '선명하고 행이 적은 문서용', hi: 'साफ़, कम पंक्तियों वाले दस्तावेज़ के लिए', ar: 'للمستندات الواضحة قليلة الصفوف' }, speed: { vi: '~ 5 giây', en: '~ 5 seconds', fr: '~ 5 secondes', es: '~ 5 segundos', id: '~ 5 detik', ja: '~ 5 秒', zh: '~ 5 秒', ko: '~ 5초', hi: '~ 5 सेकंड', ar: '~ 5 ثوانٍ' }, icon: IconZap },
    { code: 'Standard', name: { vi: 'Standard', en: 'Standard', fr: 'Standard', es: 'Estándar', id: 'Standar', ja: '標準', zh: '标准', ko: '표준', hi: 'मानक', ar: 'قياسي' }, hint: { vi: 'Cân bằng tốc độ & độ chính xác', en: 'Balance of speed & accuracy', fr: 'Équilibre vitesse & précision', es: 'Equilibrio de velocidad y precisión', id: 'Seimbang antara kecepatan & akurasi', ja: '速度と精度のバランス', zh: '兼顾速度与准确度', ko: '속도와 정확도의 균형', hi: 'गति और सटीकता का संतुलन', ar: 'توازن بين السرعة والدقة' }, speed: { vi: '~ 15 giây', en: '~ 15 seconds', fr: '~ 15 secondes', es: '~ 15 segundos', id: '~ 15 detik', ja: '~ 15 秒', zh: '~ 15 秒', ko: '~ 15초', hi: '~ 15 सेकंड', ar: '~ 15 ثانية' }, icon: IconScale },
    { code: 'Deep', name: { vi: 'Chuyên sâu', en: 'Deep', fr: 'Approfondi', es: 'Profundo', id: 'Mendalam', ja: '詳細', zh: '深度', ko: '심층', hi: 'गहन', ar: 'متعمق' }, hint: { vi: 'Tài liệu viết tay, mờ, nhiều dòng', en: 'Handwritten, blurry, many lines', fr: 'Manuscrit, flou, nombreuses lignes', es: 'Manuscrito, borroso, muchas filas', id: 'Tulisan tangan, buram, banyak baris', ja: '手書き・不鮮明・行数が多い文書', zh: '手写、模糊、行数多的文档', ko: '손글씨, 흐릿함, 행이 많은 문서', hi: 'हस्तलिखित, धुंधले, अधिक पंक्तियाँ', ar: 'مكتوب باليد، غير واضح، صفوف كثيرة' }, speed: { vi: '1 – 3 phút', en: '1 – 3 minutes', fr: '1 – 3 minutes', es: '1 – 3 minutos', id: '1 – 3 menit', ja: '1 – 3 分', zh: '1 – 3 分钟', ko: '1 – 3분', hi: '1 – 3 मिनट', ar: '1 – 3 دقائق' }, icon: IconDeep }
];

export default function Stage1Upload(props) {
    var fileInputRef = useRef(null);
    var [uploading, setUploading] = useState(false);
    var [error, setError] = useState(null);
    var [dragOver, setDragOver] = useState(false);
    var [pendingFile, setPendingFile] = useState(null);

    var mode = props.mode || 'Standard';
    var setMode = props.onModeChange || function () {};

    var doUpload = useCallback(function (f) {
        if (!f) return;
        if (props.onAnalyzeStart) props.onAnalyzeStart();
        setUploading(true);
        setError(null);
        var api = getAPI();
        var formData = new FormData();
        formData.append('files', f);
        if (props.targetTable) formData.append('target_table', props.targetTable);
        if (props.targetCode) formData.append('target_code', props.targetCode);
        if (props.targetId) formData.append('target_id', String(props.targetId));
        if (mode) formData.append('analysis_mode', mode);
        api.upload('/' + api.routeURL + '/analyzeUpload', formData, function (resp) {
            setUploading(false);
            var data = (resp && resp.data) || resp || {};
            if (data.error || !data.id) {
                var msg = (data && (data.error_message || data.message || data.error)) ||
                    AntLocalization.translateText({ vi: 'Phân tích thất bại', en: 'Analysis failed', fr: 'Échec de l’analyse', es: 'Error en el análisis', id: 'Analisis gagal', ja: '解析に失敗しました', zh: '分析失败', ko: '분석 실패', hi: 'विश्लेषण विफल', ar: 'فشل التحليل' });
                setError(typeof msg === 'string' ? msg : JSON.stringify(msg));
                if (props.onAnalyzeFailed) props.onAnalyzeFailed(data);
                return;
            }
            if (props.onAnalyzed) props.onAnalyzed(data);
        });
    }, [props.onAnalyzed, props.onAnalyzeStart, props.onAnalyzeFailed, props.targetTable, props.targetCode, props.targetId, mode]);

    var handleFileSelect = useCallback(function (e) {
        var files = e.target.files;
        if (!files || !files.length) return;
        setPendingFile(files[0]);
        e.target.value = '';
    }, []);

    var handleDrop = useCallback(function (e) {
        e.preventDefault();
        setDragOver(false);
        var files = e.dataTransfer && e.dataTransfer.files;
        if (files && files.length) setPendingFile(files[0]);
    }, []);

    // Khi caller mở popup kèm file đã chọn (vd EXPGeneralOrders/QuickWizard
    // chuyển nhánh "Upload tài liệu" sang đây), preload pendingFile để user
    // không phải chọn lại — chỉ cần xem mode & bấm Analyze.
    useEffect(function () {
        if (props.initialFile) {
            setPendingFile(props.initialFile);
            if (props.onConsumedInitialFile) props.onConsumedInitialFile();
        }
    }, [props.initialFile]);

    var openFilePicker = function () {
        if (uploading) return;
        if (fileInputRef.current) fileInputRef.current.click();
    };

    var canStart = !!pendingFile && !uploading;

    return (
        <>
        <div className="s1">
            <div className="s1-modes-block">
                <div className="s1-modes-label">
                    {AntLocalization.translateText({ vi: 'Chọn chế độ phân tích', en: 'Select analysis mode', fr: 'Choisir le mode d’analyse', es: 'Elegir modo de análisis', id: 'Pilih mode analisis', ja: '解析モードを選択', zh: '选择分析模式', ko: '분석 모드 선택', hi: 'विश्लेषण मोड चुनें', ar: 'اختر وضع التحليل' })}
                </div>
                <div className="s1-modes">
                    {MODES.map(function (m) {
                        var Ico = m.icon;
                        var active = mode === m.code;
                        return (
                            <div key={m.code}
                                className={'s1-mode' + (active ? ' is-active' : '')}
                                onClick={function () { setMode(m.code); }}
                                role="button" tabIndex={0}
                            >
                                <div className="s1-mode-ico"><Ico /></div>
                                <div className="s1-mode-body">
                                    <div className="s1-mode-name">{AntLocalization.translateText(m.name)}</div>
                                    <div className="s1-mode-hint">{AntLocalization.translateText(m.hint)}</div>
                                    <div className="s1-mode-speed">{AntLocalization.translateText(m.speed)}</div>
                                </div>
                                <div className="s1-mode-radio">
                                    {active && (
                                        <svg width="14" height="14" viewBox="0 0 16 16" fill="white">
                                            <path d="M6.5 11L3.5 8l1-1L6.5 9l5-5 1 1z" />
                                        </svg>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div
                className={'s1-drop' + (dragOver ? ' is-drag' : '') + (uploading ? ' is-busy' : '') + (pendingFile ? ' has-file' : '')}
                onClick={openFilePicker}
                onDragOver={function (e) { e.preventDefault(); setDragOver(true); }}
                onDragLeave={function () { setDragOver(false); }}
                onDrop={handleDrop}
            >
                <input ref={fileInputRef} type="file" accept="image/*,.pdf" style={{ display: 'none' }} onChange={handleFileSelect} />
                <div className="doc-art">
                    <span className="spark spark-1" />
                    <span className="spark spark-2" />
                    <span className="spark spark-3" />
                    <span className="spark spark-4" />
                    <div className="sheet" />
                    <div className="line l1" /><div className="line l2" /><div className="line l3" />
                    <div className="line l4" /><div className="line l5" />
                    <div className="badge"><IconArrowUp /></div>
                </div>
                {pendingFile ? (
                    <>
                        <div className="lede">{pendingFile.name}</div>
                        <div className="sub">
                            {(pendingFile.size / 1024).toFixed(1)} KB ·{' '}
                            <a href="#" onClick={function (e) { e.preventDefault(); e.stopPropagation(); setPendingFile(null); openFilePicker(); }}>
                                {AntLocalization.translateText({ vi: 'chọn lại', en: 'choose again', fr: 'changer', es: 'elegir otro', id: 'pilih ulang', ja: '選び直す', zh: '重新选择', ko: '다시 선택', hi: 'फिर चुनें', ar: 'اختيار آخر' })}
                            </a>
                        </div>
                    </>
                ) : uploading ? (
                    <>
                        <div className="lede">{AntLocalization.translateText({ vi: 'Đang tải lên…', en: 'Uploading…', fr: 'Envoi…', es: 'Subiendo…', id: 'Mengunggah…', ja: 'アップロード中…', zh: '上传中…', ko: '업로드 중…', hi: 'अपलोड हो रहा है…', ar: 'جارٍ الرفع…' })}</div>
                        <div className="sub"><span className="aiva-inline-spin" /></div>
                    </>
                ) : (
                    <>
                        <div className="lede">{AntLocalization.translateText({ vi: 'Kéo thả tài liệu vào đây', en: 'Drag & drop document here', fr: 'Glissez-déposez le document ici', es: 'Arrastra y suelta el documento', id: 'Seret & lepas dokumen di sini', ja: 'ここに文書をドロップ', zh: '将文档拖放到此处', ko: '문서를 여기에 끌어다 놓기', hi: 'दस्तावेज़ यहाँ खींचकर छोड़ें', ar: 'اسحب المستند وأفلته هنا' })}</div>
                        <div className="sub">
                            {AntLocalization.translateText({ vi: 'hoặc ', en: 'or ', fr: 'ou ', es: 'o ', id: 'atau ', ja: 'または', zh: '或 ', ko: '또는 ', hi: 'या ', ar: 'أو ' })}
                            <a href="#" onClick={function (e) { e.preventDefault(); }}>{AntLocalization.translateText({ vi: 'bấm để chọn', en: 'click to select', fr: 'parcourir', es: 'elige un archivo', id: 'klik untuk memilih', ja: 'クリックして選択', zh: '点击选择', ko: '클릭하여 선택', hi: 'क्लिक करके चुनें', ar: 'انقر للاختيار' })}</a>
                            {AntLocalization.translateText({ vi: ' từ máy', en: ' from device', fr: ' sur l’appareil', es: ' del equipo', id: ' dari perangkat', ja: '（端末から）', zh: ' 本地文件', ko: ' (기기에서)', hi: ' डिवाइस से', ar: ' من الجهاز' })}
                        </div>
                    </>
                )}
                <div className="types-wrap">
                    <span className="types-label">
                        {AntLocalization.translateText({ vi: 'Hỗ trợ định dạng:', en: 'Supported formats:', fr: 'Formats acceptés :', es: 'Formatos admitidos:', id: 'Format didukung:', ja: '対応形式:', zh: '支持格式:', ko: '지원 형식:', hi: 'समर्थित फ़ॉर्मेट:', ar: 'الصيغ المدعومة:' })}
                    </span>
                    <div className="types">
                        <span className="type type-pdf"><IconFile color="#dc2626" /> PDF</span>
                        <span className="type type-jpg"><IconImage color="#16a34a" /> JPG</span>
                        <span className="type type-png"><IconImage color="#9333ea" /> PNG</span>
                    </div>
                </div>
            </div>

            {error && <div className="ant-aiva-error">{error}</div>}
        </div>
        <div className="pp-foot pp-foot-split">
            <div className="pp-foot-info">
                <span className="pp-foot-info-ico"><IconInfo /></span>
                {AntLocalization.translateText({
                    vi: 'Tài liệu của bạn được xử lý bảo mật và không lưu trữ sau khi phân tích.',
                    en: 'Your document is processed securely and not stored after analysis.',
                    fr: 'Votre document est traité de façon sécurisée et n’est pas conservé après l’analyse.',
                    es: 'Tu documento se procesa de forma segura y no se guarda tras el análisis.',
                    id: 'Dokumen Anda diproses secara aman dan tidak disimpan setelah analisis.',
                    ja: '文書は安全に処理され、解析後は保存されません。',
                    zh: '您的文档将被安全处理，分析后不会保存。',
                    ko: '문서는 안전하게 처리되며 분석 후 저장되지 않습니다.',
                    hi: 'आपका दस्तावेज़ सुरक्षित रूप से प्रोसेस होता है और विश्लेषण के बाद सहेजा नहीं जाता।',
                    ar: 'تتم معالجة مستندك بأمان ولا يُحفظ بعد التحليل.'
                })}
            </div>
            <div className="pp-foot-actions">
                <button type="button" className="btn btn-secondary" onClick={props.onClose}>
                    {AntLocalization.translateText({ vi: 'Bỏ', en: 'Cancel', fr: 'Annuler', es: 'Cancelar', id: 'Batal', ja: '取消', zh: '取消', ko: '취소', hi: 'रद्द करें', ar: 'إلغاء' })}
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    disabled={!canStart}
                    onClick={function () { if (canStart) doUpload(pendingFile); }}
                >
                    <IconSparkle /> {AntLocalization.translateText({ vi: 'Bắt đầu phân tích', en: 'Start analysis', fr: 'Lancer l’analyse', es: 'Iniciar análisis', id: 'Mulai analisis', ja: '解析を開始', zh: '开始分析', ko: '분석 시작', hi: 'विश्लेषण शुरू करें', ar: 'بدء التحليل' })}
                </button>
            </div>
        </div>
        </>
    );
}
